const endpoints = {
	getPaymentOrders: '/payments/getPaymentOrders',
	getPaymentOrder: '/payments/getPaymentOrder',
	createPaymentOrder: '/payments/createPaymentOrder',
	createManualPayment: '/payments/createManualPayment',
}
export {endpoints}